import { useCallback, useState } from 'react';
import {
  BtnBold,
  BtnItalic,
  Editor,
  EditorProvider,
  Toolbar,
  ContentEditableEvent,
  BtnUndo,
  BtnRedo,
  BtnUnderline,
  BtnStyles,
} from 'react-simple-wysiwyg';
import { FlexContainer } from 'shared/Typhography/flex-box';

interface TextEditorProps {
  setValue?: (value: string) => void;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
}

export const TextEditor = ({ setValue, value, disabled, placeholder }: TextEditorProps) => {
  const [html, setHtml] = useState<string>(value ?? '');

  const onChange = useCallback(
    (event: ContentEditableEvent) => {
      setValue && setValue(event.target.value);
      setHtml(event.target.value);
    },
    [setValue],
  );

  return (
    <EditorProvider>
      <Editor
        placeholder={placeholder}
        disabled={disabled}
        containerProps={{ style: { width: '100%' } }}
        value={html}
        onChange={onChange}
      >
        <Toolbar>
          <FlexContainer
            gap="20px"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            dimensions={{ width: '100%' }}
          >
            <FlexContainer flexDirection="row" alignItems="center" gap="10px">
              <BtnBold />
              <BtnItalic />
              <BtnUnderline />
            </FlexContainer>
            <BtnStyles />
            <FlexContainer flexDirection="row" alignItems="center" gap="10px">
              <BtnUndo />
              <BtnRedo />
            </FlexContainer>
          </FlexContainer>
        </Toolbar>
      </Editor>
    </EditorProvider>
  );
};
